import { Typography } from '@mui/material';

type Props = {
    text: string;
};

const Description = ({ text }: Props) => {
    return <Typography variant={'body1'} dangerouslySetInnerHTML={{ __html: text }} sx={{ margin: '16px 0 16px 0' }} />;
};

export default Description;
